import { createInertiaApp } from '@inertiajs/react'
import type { ComponentType } from 'react'

const pages = import.meta.glob<{ default: ComponentType }>([
  '../pages/**/*.tsx',
  '!../pages/**/*.test.tsx',
])

void createInertiaApp({
  resolve: async (name) => {
    const loadPage = pages[`../pages/${name}.tsx`]
    if (!loadPage) throw new Error(`Page not found: ${name}`)

    return (await loadPage()).default
  },

  strictMode: true,

  defaults: {
    form: {
      forceIndicesArrayFormatInFormData: false,
      withAllErrors: true,
    },
    visitOptions: () => {
      return { queryStringArrayFormat: "brackets" }
    },
  },
}).catch((error) => {
  // This ensures this entrypoint is only loaded on Inertia pages
  // by checking for the presence of the root element (#app by default).
  // Feel free to remove this `catch` if you don't need it.
  if (document.getElementById("app")) {
    throw error
  } else {
    console.error(
      "Missing root element.\n\n" +
      "If you see this error, it probably means you loaded Inertia.js on non-Inertia pages.\n" +
      'Consider moving <%= vite_typescript_tag "inertia.tsx" %> to the Inertia-specific layout instead.',
    )
  }
})
